import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import GatewayRegistryBasicInfoComponent from './gateway-registries-basic-info.component';
import GatewayRedisAndLogisticsInfoComponent from './gateway-redis-logistics-info.component';
import GatewaySettingsInfoComponent from './gateway-settings-info.component';
import GatewayDomainsInfoComponent from './gateway-domain-info.component';
import GatewayWhiteListedRoutesInfoComponent from './gateway-white-listed-info.component';
import GatewayBlacklistedNPsInfoComponent from './gateway-black-listed-info.component';
import GatewayIncludedCitiesForCatalogInfoComponent from './gateway-included-cities-info.component';
import GatewayExcludedCitiesForCatalogInfoComponent from './gateway-excluded-cities-info.component';
import GatewayMaskedKeywordsInfoComponent from './gateway-masked-keywords.component';
import GatewayPollingInfoComponent from './gateway-polling-info.component';
export const GatewayRegistryComponent = ({
  gateways,
  domains,
  maskedKeywords,
  excludedCitiesForCatalog,
  includedCitiesForCatalog,
  blacklistedNPs,
  whitelistedRoutes,
  handleFormMaskedKeywordsItemChange,
  handleFormExcludedCitiesForCatalogItemChange,
  handleFormIncludedCitiesForCatalogItemChange,
  handleFormBlacklistedNPsItemChange,
  handleFormWhitelistedRoutesItemChange,
  handleFormDomainsItemChange, stores,
  handleFormChange, selectedGateway,
  handleInnerFormChange,
  handleDeleteBlacklisedNps,
  handleDeleteDomains,
  handleDeleteExcludedCities,
  handleDeleteIncludedCities,
  handleDeleteMaskedKeywords,
  handleDeleteWhitelistedRoutes,
  channelsList,
  domainDetails,
  networks,
  back,
  handleFormSubmit
}: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Basic Information',
      component: <GatewayRegistryBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        handleFormChange={handleFormChange}
        selectedGateway={selectedGateway}
        gateways={gateways}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Settings',
      component: <GatewaySettingsInfoComponent
        domains={domainDetails}
        handleFormChange={handleFormChange}
        channelsList={channelsList}
        selectedGateway={selectedGateway}
        stores={stores}
      />,
      isVisible: true,
    },
    {
      id: 3,
      title: 'Domains Details',
      component: <GatewayDomainsInfoComponent
        handleFormDomainsItemChange={handleFormDomainsItemChange}
        handleDelete={handleDeleteDomains}
        domains={domains}
        domainsList={domainDetails}
      />,
      isVisible: true,
    },
    {
      id: 4,
      title: 'Whitelisted Routes',
      component: <GatewayWhiteListedRoutesInfoComponent
        handleFormWhitelistedRoutesItemChange={handleFormWhitelistedRoutesItemChange}
        handleDelete={handleDeleteWhitelistedRoutes}
        whitelistedRoutes={whitelistedRoutes}
      />,
      isVisible: true,
    },
    {
      id: 5,
      title: 'Blacklisted NPs',
      component: <GatewayBlacklistedNPsInfoComponent
        handleFormBlacklistedNPsItemChange={handleFormBlacklistedNPsItemChange}
        handleDelete={handleDeleteBlacklisedNps}
        blacklistedNPs={blacklistedNPs}
      />,
      isVisible: true,
    },
    {
      id: 6,
      title: 'Included Cities For Catalog',
      component: <GatewayIncludedCitiesForCatalogInfoComponent
        handleFormIncludedCitiesForCatalogItemChange={handleFormIncludedCitiesForCatalogItemChange}
        handleDelete={handleDeleteIncludedCities}
        includedCitiesForCatalog={includedCitiesForCatalog}
      />,
      isVisible: true,
    },
    {
      id: 7,
      title: 'Excluded Cities For Catalog',
      component: <GatewayExcludedCitiesForCatalogInfoComponent
        handleFormExcludedCitiesForCatalogItemChange={handleFormExcludedCitiesForCatalogItemChange}
        handleDelete={handleDeleteExcludedCities}
        excludedCitiesForCatalog={excludedCitiesForCatalog}
      />,
      isVisible: true,
    },
    {
      id: 8,
      title: 'Masked Keywords',
      component: <GatewayMaskedKeywordsInfoComponent
        handleFormMaskedKeywordsItemChange={handleFormMaskedKeywordsItemChange}
        handleDelete={handleDeleteMaskedKeywords}
        maskedKeywords={maskedKeywords}
      />,
      isVisible: true,
    },
    //   {
    //     id:9,
    //     title:'Logistics Info',
    //     component:<GatewayRedisAndLogisticsInfoComponent 
    //     handleFormChange={handleFormChange}
    //     selectedGateway={selectedGateway}
    //     domainsList={domainDetails}
    //     />,
    // isVisible:true,
    // },
    // {
    //     id:10,
    //     title:'Polling',
    //     component:<GatewayPollingInfoComponent 
    //     handleFormChange={handleFormChange}
    //     selectedGateway={selectedGateway}
    //     />,
    // isVisible:true,
    // },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default GatewayRegistryComponent;
